import { render, staticRenderFns } from "./OtherSpouse.vue?vue&type=template&id=061a2b7d&scoped=true&"
import script from "./OtherSpouse.vue?vue&type=script&lang=js&"
export * from "./OtherSpouse.vue?vue&type=script&lang=js&"
import style0 from "./OtherSpouse.vue?vue&type=style&index=0&id=061a2b7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061a2b7d",
  null
  
)

export default component.exports